import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminDeleteChart = () => {
  const queryClient = useQueryClient();

  return apiClient.chart.deleteChart.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-charts-list'] });
      toast.success('Chart deleted successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Failed to delete chart');
    },
  });
};
